(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["03-decoramics-best-sellers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('decoramics-product-rail')) {
    customElements.define('decoramics-product-rail', class extends HTMLElement {
      connectedCallback() {
        this.rail = this.querySelector('[data-product-rail]');
        this.previous = this.querySelector('[data-rail-previous]');
        this.next = this.querySelector('[data-rail-next]');
        if (!this.rail || !this.previous || !this.next) return;
        this.previous.addEventListener('click', () => this.move(-1));
        this.next.addEventListener('click', () => this.move(1));
        this.rail.addEventListener('scroll', () => this.updateControls(), { passive: true });
        new ResizeObserver(() => this.updateControls()).observe(this.rail);
        this.updateControls();
      }

      move(direction) {
        const card = this.rail.querySelector('.decoramics-products__card');
        if (!card) return;
        const gap = parseFloat(getComputedStyle(this.rail).columnGap) || 0;
        this.rail.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
      }

      updateControls() {
        const maximum = this.rail.scrollWidth - this.rail.clientWidth;
        this.previous.disabled = this.rail.scrollLeft <= 2;
        this.next.disabled = this.rail.scrollLeft >= maximum - 2;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["04-decoramics-story-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('decoramics-story-video')) {
    customElements.define('decoramics-story-video', class extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        this.toggle = this.querySelector('[data-video-toggle]');
        if (!this.video || !this.toggle) return;
        this.toggle.addEventListener('click', () => this.togglePlayback());
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          this.video.pause();
          this.setPaused(true);
        }
      }

      togglePlayback() {
        if (this.video.paused) {
          this.video.play();
          this.setPaused(false);
        } else {
          this.video.pause();
          this.setPaused(true);
        }
      }

      setPaused(paused) {
        this.toggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
        this.toggle.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["05-decoramics-community-feed"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('decoramics-community-feed')) {
    customElements.define('decoramics-community-feed', class extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('[data-community-play]').forEach(button => {
          button.addEventListener('click', () => this.toggleVideo(button));
        });
      }

      toggleVideo(button) {
        const card = button.closest('[data-community-card]');
        const video = card ? card.querySelector('video') : null;
        if (!card || !video) return;
        this.querySelectorAll('[data-community-card]').forEach(otherCard => {
          if (otherCard === card) return;
          const otherVideo = otherCard.querySelector('video');
          const otherButton = otherCard.querySelector('[data-community-play]');
          if (otherVideo) otherVideo.pause();
          otherCard.classList.remove('is-playing');
          if (otherButton) {
            otherButton.setAttribute('aria-pressed', 'false');
            otherButton.setAttribute('aria-label', otherButton.getAttribute('aria-label').replace('Pause', 'Play'));
          }
        });
        if (video.paused) {
          video.play();
          card.classList.add('is-playing');
          button.setAttribute('aria-pressed', 'true');
          button.setAttribute('aria-label', button.getAttribute('aria-label').replace('Play', 'Pause'));
        } else {
          video.pause();
          card.classList.remove('is-playing');
          button.setAttribute('aria-pressed', 'false');
          button.setAttribute('aria-label', button.getAttribute('aria-label').replace('Pause', 'Play'));
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["08-decoramics-trust"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('decoramics-trust'))customElements.define('decoramics-trust',class extends HTMLElement{connectedCallback(){this.rail=this.querySelector('[data-trust-rail]');this.dots=[...this.querySelectorAll('[data-trust-dot]')];this.dots.forEach((d,i)=>d.addEventListener('click',()=>this.rail.scrollTo({left:i*this.rail.clientWidth,behavior:'smooth'})));this.rail.addEventListener('scroll',()=>{const i=Math.round(this.rail.scrollLeft/this.rail.clientWidth);this.dots.forEach((d,n)=>n===i?d.setAttribute('aria-current','true'):d.removeAttribute('aria-current'))},{passive:true})}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dc-pdp-04-demo"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dc-pdp-demo')) {
    customElements.define('dc-pdp-demo', class extends HTMLElement {
      connectedCallback() {
        cancelAnimationFrame(this.initFrame);
        this.initFrame = requestAnimationFrame(() => {
          if (this.isConnected) this.initialize();
        });
      }
      initialize() {
        this.abortController?.abort();
        this.abortController = new AbortController();
        const button = this.querySelector('[data-dc-toggle]');
        const first = this.querySelector('[data-dc-view="first"]');
        const second = this.querySelector('[data-dc-view="second"]');
        if (!button || !first || !second) return;
        const label = button.querySelector('[data-dc-toggle-label]');
        const status = this.querySelector('[data-dc-status]');
        button.hidden = false;
        button.addEventListener('click', () => {
          const showSecond = button.getAttribute('aria-pressed') !== 'true';
          first.hidden = showSecond;
          second.hidden = !showSecond;
          button.setAttribute('aria-pressed', String(showSecond));
          label.textContent = showSecond ? button.dataset.labelSecond : button.dataset.labelFirst;
          status.textContent = showSecond ? button.dataset.statusSecond : button.dataset.statusFirst;
        }, { signal: this.abortController.signal });
      }
      disconnectedCallback() { cancelAnimationFrame(this.initFrame); this.abortController?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dc-pdp-05-value-strip"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dc-pdp-value-strip')) {
    customElements.define('dc-pdp-value-strip', class extends HTMLElement {
      connectedCallback() {
        cancelAnimationFrame(this.initFrame);
        this.initFrame = requestAnimationFrame(() => {
          if (this.isConnected) this.initialize();
        });
      }
      initialize() {
        this.cleanup?.abort();
        this.cleanup = new AbortController();
        this.classList.add('dc05-ready');
        if (this.dataset.animate === 'true') this.classList.add('dc05-moving');
        this.querySelector('button')?.addEventListener('click', () => {
          const paused = this.classList.toggle('dc05-paused');
          const button = this.querySelector('button');
          button.setAttribute('aria-pressed', String(paused));
          button.setAttribute('aria-label', paused ? 'Resume scrolling messages' : 'Pause scrolling messages');
          this.querySelector('[data-pause-icon]').hidden = paused;
          this.querySelector('[data-play-icon]').hidden = !paused;
        }, {signal:this.cleanup.signal});
      }
      disconnectedCallback() { cancelAnimationFrame(this.initFrame); this.cleanup?.abort(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dc-pdp-06-community"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dc-pdp-community')) {
    customElements.define('dc-pdp-community', class extends HTMLElement {
      connectedCallback() {
        cancelAnimationFrame(this.initFrame);
        this.initFrame = requestAnimationFrame(() => {
          if (this.isConnected) this.initialize();
        });
      }
      initialize() {
        this.abort?.abort();
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.rail = this.querySelector('.dc-community-rail');
        if (!this.rail) return;
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        const update = () => {
          const maximum = this.rail.scrollWidth - this.rail.clientWidth;
          const position = Math.abs(this.rail.scrollLeft);
          this.querySelector('[data-navigation]').hidden = maximum < 2;
          this.prev.disabled = position < 2;
          this.next.disabled = position > maximum - 2;
        };
        const step = (direction) => {
          const card = this.rail.querySelector('[data-card]');
          if (!card) return;
          const gap = parseFloat(getComputedStyle(this.rail).columnGap) || 0;
          const rtl = getComputedStyle(this.rail).direction === 'rtl' ? -1 : 1;
          this.rail.scrollBy({ left: direction * rtl * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        this.prev.addEventListener('click', () => step(-1), { signal });
        this.next.addEventListener('click', () => step(1), { signal });
        this.rail.addEventListener('scroll', update, { passive:true, signal });
        this.rail.addEventListener('keydown', (event) => {
          if (event.target !== this.rail || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          const rtl = getComputedStyle(this.rail).direction === 'rtl';
          step((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
        }, { signal });
        this.querySelectorAll('video').forEach((video) => {
          const play = video.parentElement.querySelector('[data-play]');
          play.hidden = false;
          play.addEventListener('click', () => { video.play().catch(() => { play.hidden = true; video.focus(); }); }, { signal });
          video.addEventListener('play', () => { play.hidden = true; }, { signal });
          video.addEventListener('pause', () => { play.hidden = false; }, { signal });
          video.addEventListener('ended', () => { play.hidden = false; }, { signal });
        });
        document.addEventListener('play', (event) => {
          if (!(event.target instanceof HTMLVideoElement) || !event.target.closest('[data-dc-pdp-media]')) return;
          this.querySelectorAll('video').forEach((video) => { if (video !== event.target) video.pause(); });
        }, { capture:true, signal });
        document.addEventListener('visibilitychange', () => { if (document.hidden) this.querySelectorAll('video').forEach((video) => video.pause()); }, { signal });
        document.addEventListener('shopify:block:select', (event) => {
          const card = event.target.closest('[data-card]');
          if (card && this.contains(card)) card.scrollIntoView({ block:'nearest', inline:'start', behavior:'instant' });
        }, { signal });
        this.resize?.disconnect();
        this.resize = new ResizeObserver(update);
        this.resize.observe(this.rail);
        update();
      }
      disconnectedCallback() { cancelAnimationFrame(this.initFrame);
        this.abort?.abort();
        this.resize?.disconnect();
        this.querySelectorAll('video').forEach((video) => video.pause());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dc-pdp-08-showcase"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dc-pdp-showcase')) {
    customElements.define('dc-pdp-showcase', class extends HTMLElement {
      connectedCallback() {
        cancelAnimationFrame(this.initFrame);
        this.initFrame = requestAnimationFrame(() => {
          if (this.isConnected) this.initialize();
        });
      }
      initialize() {
        this.abort?.abort();
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.rail = this.querySelector('.dc-showcase-rail');
        if (!this.rail) return;
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        const update = () => {
          const maximum = this.rail.scrollWidth - this.rail.clientWidth;
          const position = Math.abs(this.rail.scrollLeft);
          this.querySelector('[data-navigation]').hidden = maximum < 2;
          this.prev.disabled = position < 2;
          this.next.disabled = position > maximum - 2;
        };
        const step = (direction) => {
          const card = this.rail.querySelector('[data-card]');
          if (!card) return;
          const gap = parseFloat(getComputedStyle(this.rail).columnGap) || 0;
          const rtl = getComputedStyle(this.rail).direction === 'rtl' ? -1 : 1;
          this.rail.scrollBy({ left: direction * rtl * (card.getBoundingClientRect().width + gap), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        this.prev.addEventListener('click', () => step(-1), { signal });
        this.next.addEventListener('click', () => step(1), { signal });
        this.rail.addEventListener('scroll', update, { passive:true, signal });
        this.rail.addEventListener('keydown', (event) => {
          if (event.target !== this.rail || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          const rtl = getComputedStyle(this.rail).direction === 'rtl';
          step((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
        }, { signal });
        this.querySelectorAll('video').forEach((video) => {
          const play = video.parentElement.querySelector('[data-play]');
          play.hidden = false;
          play.addEventListener('click', () => { video.play().catch(() => { play.hidden = true; video.focus(); }); }, { signal });
          video.addEventListener('play', () => { play.hidden = true; }, { signal });
          video.addEventListener('pause', () => { play.hidden = false; }, { signal });
          video.addEventListener('ended', () => { play.hidden = false; }, { signal });
        });
        document.addEventListener('play', (event) => {
          if (!(event.target instanceof HTMLVideoElement) || !event.target.closest('[data-dc-pdp-media]')) return;
          this.querySelectorAll('video').forEach((video) => { if (video !== event.target) video.pause(); });
        }, { capture:true, signal });
        document.addEventListener('visibilitychange', () => { if (document.hidden) this.querySelectorAll('video').forEach((video) => video.pause()); }, { signal });
        document.addEventListener('shopify:block:select', (event) => {
          const card = event.target.closest('[data-card]');
          if (card && this.contains(card)) card.scrollIntoView({ block:'nearest', inline:'start', behavior:'instant' });
        }, { signal });
        this.resize?.disconnect();
        this.resize = new ResizeObserver(update);
        this.resize.observe(this.rail);
        update();
      }
      disconnectedCallback() { cancelAnimationFrame(this.initFrame);
        this.abort?.abort();
        this.resize?.disconnect();
        this.querySelectorAll('video').forEach((video) => video.pause());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dc-pdp-11-recommendations"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dc-pdp-recommendations')) {
    customElements.define('dc-pdp-recommendations', class extends HTMLElement {
      connectedCallback() {
        cancelAnimationFrame(this.initFrame);
        this.initFrame = requestAnimationFrame(() => {
          if (this.isConnected) this.initialize();
        });
      }
      initialize() {
        this.abort?.abort();
        this.loading = false;
        this.abort = new AbortController();
        this.setupRail();
        if (this.dataset.intent === 'manual' || this.dataset.performed === 'true' || !this.dataset.productId || this.loaded) return;
        this.observer?.disconnect();
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver((entries) => {
            if (entries.some((entry) => entry.isIntersecting)) { this.observer.disconnect(); this.load(); }
          }, { rootMargin:'300px' });
          this.observer.observe(this);
        } else {
          this.load();
        }
      }
      setupRail() {
        this.railAbort?.abort();
        this.railAbort = new AbortController();
        this.resize?.disconnect();
        const signal = this.railAbort.signal;
        const rail = this.querySelector('.dc-recommendations-rail');
        if (!rail) return;
        const prev = this.querySelector('[data-prev]');
        const next = this.querySelector('[data-next]');
        const update = () => {
          const maximum = rail.scrollWidth - rail.clientWidth;
          const position = Math.abs(rail.scrollLeft);
          this.querySelector('[data-navigation]').hidden = maximum < 2;
          prev.disabled = position < 2;
          next.disabled = position > maximum - 2;
        };
        const step = (direction) => {
          const card = rail.querySelector('[data-card]');
          if (!card) return;
          const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
          const rtl = getComputedStyle(rail).direction === 'rtl' ? -1 : 1;
          rail.scrollBy({ left:direction * rtl * (card.getBoundingClientRect().width + gap), behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        prev.addEventListener('click', () => step(-1), { signal });
        next.addEventListener('click', () => step(1), { signal });
        rail.addEventListener('scroll', update, { passive:true, signal });
        rail.addEventListener('keydown', (event) => {
          if (event.target !== rail || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          const rtl = getComputedStyle(rail).direction === 'rtl';
          step((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1));
        }, { signal });
        this.resize = new ResizeObserver(update);
        this.resize.observe(rail);
        update();
      }
      async load() {
        if (this.loading) return;
        this.loading = true;
        const controller = this.abort;
        try {
          const url = new URL(this.dataset.url, window.location.origin);
          url.searchParams.set('section_id', this.dataset.sectionId);
          url.searchParams.set('product_id', this.dataset.productId);
          url.searchParams.set('limit', this.dataset.limit);
          url.searchParams.set('intent', this.dataset.intent);
          const response = await fetch(url.toString(), { signal:controller.signal });
          if (!response.ok) throw new Error('Recommendations unavailable');
          const documentFragment = new DOMParser().parseFromString(await response.text(), 'text/html');
          if (controller !== this.abort || controller.signal.aborted || !this.isConnected) return;
          const incoming = documentFragment.getElementById(this.id)?.querySelector('[data-content]');
          if (incoming) {
            this.querySelector('[data-content]').replaceWith(document.importNode(incoming, true));
            this.setupRail();
            this.loaded = true;
            this.dataset.performed = 'true';
          }
        } catch (error) {
          if (controller === this.abort && error.name !== 'AbortError') this.dataset.loadError = 'true';
          // Keep merchant-selected fallback products visible on network/API failure.
        } finally {
          if (controller === this.abort) this.loading = false;
        }
      }
      disconnectedCallback() { cancelAnimationFrame(this.initFrame);
        this.abort?.abort();
        this.railAbort?.abort();
        this.resize?.disconnect();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dc-pdp-12-service-promises"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dc-pdp-promises')) {
    customElements.define('dc-pdp-promises', class extends HTMLElement {
      connectedCallback() {
        cancelAnimationFrame(this.initFrame);
        this.initFrame = requestAnimationFrame(() => {
          if (this.isConnected) this.initialize();
        });
      }
      initialize() {
        this.cleanup?.abort(); this.cleanup = new AbortController();
        const signal = this.cleanup.signal;
        const rail = this.querySelector('.dc12-rail');
        this.classList.add('dc12-ready');
        const buttons = [...this.querySelectorAll('button[data-index]')];
        const move = index => rail.scrollTo({left:rail.children[index].offsetLeft-rail.children[0].offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
        buttons.forEach(button => button.addEventListener('click',()=>move(Number(button.dataset.index)),{signal}));
        rail.addEventListener('scroll',()=>{
          cancelAnimationFrame(this.frame);
          this.frame=requestAnimationFrame(()=>{
            const current=Math.round(Math.abs(rail.scrollLeft)/rail.clientWidth);
            buttons.forEach((button,index)=>button.setAttribute('aria-current',String(index===current)));
          });
        },{passive:true,signal});
        this.addEventListener('shopify:block:select',event=>{
          const item=event.target.closest('.dc12-item');
          if(item&&matchMedia('(max-width:749px)').matches) move([...rail.children].indexOf(item));
        },{signal});
      }
      disconnectedCallback() { cancelAnimationFrame(this.initFrame);this.cleanup?.abort();cancelAnimationFrame(this.frame);}
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
